
import { defineComponent, ref } from "vue";
import InputText from "primevue/inputtext";
import NextStepButton from "@/components/NextStepButton.vue";

export default defineComponent({
  name: "ForgotPassword",
  components: { InputText, NextStepButton },
  setup(props, { emit }) {
    const email = ref("");
    const onEmailReset = ref(false);
    const code = ref("");
    const pass = ref("");
    const confirm = ref("");
    const sendResetEmail = () => {
      onEmailReset.value = true;
    };
    const submit = () => {
      emit("submit");
    };
    return {
      email,
      onEmailReset,
      code,
      pass,
      confirm,
      sendResetEmail,
      submit,
    };
  },
});
